import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';

const AutoClosingModal = ({ show, onClose, message, timeout }) => {
  useEffect(() => {
    if (show) {
        console.log('Auto-Close Modal is open')
      const timer = setTimeout(() => {
        onClose();
      }, timeout);
      return () => clearTimeout(timer);
    }
  }, [show, onClose, timeout]);

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Notification</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
    </Modal>
  );
};


export default AutoClosingModal;
